$(function() {
  const $glossary = $("#glossary-content");
  const $input = $("#InputName");

  $input.on("input", function () {
  const keyword = $(this).val().trim().toLowerCase();

  $glossary.unmark({
    done: function () {
      if (keyword) {
        $glossary.mark(keyword);

        $glossary.find('li > div.btn').each(function() {
          const text = $(this).text().toLowerCase();
          if (text.indexOf(keyword) !== -1) {
            $(this).closest('li').show();
          } else {
            $(this).closest('li').hide();
          }
        });

        $glossary.find('.item').each(function() {
          const visibleTerms = $(this).find('li:visible').length;
          if (visibleTerms === 0) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });

      } else {
        // Show all when input is empty
        $glossary.find('.item').show();
        $glossary.find('li').show();
        // Remove any leftover highlights just in case
        $glossary.unmark();
      }
    }
  });
});


});


  document.addEventListener("DOMContentLoaded", function () {
      // Your existing modal code (unchanged)
    const buttons = document.querySelectorAll('[data-bs-toggle="modal"]');
    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const title = this.getAttribute('data-title');
        const content = this.getAttribute('data-content');

        document.getElementById('exampleModalLabel').textContent = title;
        document.getElementById('modalContent').textContent = content;
      });
    });


    const modalEl = document.getElementById("exampleModal");
    const modalContent = modalEl.querySelector(".modal-content");

    let startY = 0;
    let currentY = 0;
    let isDragging = false;

    function isMobile() {
      return window.innerWidth < 992;
    }

    // Listen for modal open to reset any transforms
    modalEl.addEventListener("shown.bs.modal", () => {
      modalContent.style.transform = "";
      modalContent.style.transition = "";
    });

    modalContent.addEventListener("touchstart", (e) => {
      if (!isMobile()) return;
      startY = e.touches[0].clientY;
      isDragging = true;
      modalContent.style.transition = "none";
    });

    modalContent.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;

      if (deltaY > 0) {
        modalContent.style.transform = `translateY(${deltaY}px)`;
      }
    });

    modalContent.addEventListener("touchend", () => {
      if (!isDragging) return;

      const deltaY = currentY - startY;

      if (deltaY > 100) {
        const instance = bootstrap.Modal.getInstance(modalEl);
        instance.hide();
      } else {
        // Snap back
        modalContent.style.transition = "transform 0.3s ease";
        modalContent.style.transform = "translateY(0)";
      }

      // Reset
      isDragging = false;
      startY = 0;
      currentY = 0;
    });
  });